import { FeatureConfiguration } from "features";
import { Yumpingo } from "./components/Yumpingo";

export default function (config: FeatureConfiguration) {
    config.addRoutes(config.routes.locationRoutes, [<Yumpingo key="yumpingo" />]);
}
